import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "react-query";
import { TextInput, TextAreaInput } from "../../react-hook-form-inputs";
import {
  createTeamMember,
  updateTeamMember,
} from "../../../queries/company";
import { renderRailsErrors } from "../../../utils/rails_error_parser";

// import "./../affiliation/affiliation.scss";
// import "./TeamMemberForm.scss";

const TeamMemberSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required"),
  role: Yup.string().required("Role is required"),
  bio: Yup.string().required("Bio is required")
})

export default function TeamMemberForm({companyId, teamMember={}, onSuccess}) {
  const queryClient = useQueryClient();

  const isUpdate = teamMember.hasOwnProperty('id')

  const methods = useForm({
    resolver: yupResolver(TeamMemberSchema),
    mode: "onTouched",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      name: teamMember.name || "",
      role: teamMember.role || "",
      bio: teamMember.bio || ""
    },
  });

  const createMutation = useMutation(
    createTeamMember,
    {
      onSuccess: (teamMember) => {
        if (typeof onSuccess === 'function') onSuccess(teamMember)
        toast.success('Team member created.');
        queryClient.invalidateQueries(
          ["team-members-list", companyId],
          {
            exact: true,
          }
        )
      },
      onError: (error) => {
        renderRailsErrors(error)
      },
    }
  )

  const updateMutation = useMutation(
    updateTeamMember,
    {
      onSuccess: (teamMember) => {
        if (typeof onSuccess === 'function') onSuccess(teamMember)
        toast.success('Team member updated.');
        queryClient.invalidateQueries(
          ["team-members-list", companyId],
          {
            exact: true,
          }
        )
      },
      onError: (error) => {
        renderRailsErrors(error)
      },
    }
  )

  const onSubmit = (values) => {
    isUpdate
      ?
        updateMutation.mutate({
          company_id: companyId,
          team_member_id: teamMember.id,
          values: {team_member: values}  
        })
      :
        createMutation.mutate({
          company_id: companyId,
          values: {team_member: values}
        })
  }

  return(
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>

        <div className="row">
          <div className="col">
            <TextInput
              name="name"
              placeholder="Name"
            />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <TextInput
              name="role"
              placeholder="Role"
            />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <TextAreaInput
              name="bio"
              placeholder="Bio"
            />
          </div>
        </div>

        <div className="form-group">
          <button type="submit"
            className="mx-auto btn btn-outline-dark rounded-0"
            disabled={methods.isSubmitting}
          >
            {`${isUpdate ? 'Update' : 'Create'} Team Member`}
          </button>
        </div>
      </form>
    </FormProvider>
  )
}
